export default {
    billing: {
        nivel: "basico",
        cuando: ["Ver y pagar las facturas mensuales.", "Administrar métodos de pago y créditos.", "Descargar facturas para contabilidad."],
        evita: ["Analizar en qué se gasta: Cost Explorer.", "Controlar el gasto con alertas: Budgets."],
        alt: [["costexplorer", "Análisis de costos."], ["budgets", "Alertas y límites."]],
        cobro: "El panel de facturación no tiene costo.",
        con: ["costexplorer", "budgets", "organizations"],
        quiz: { p: "¿Cada cuánto factura AWS el uso?", o: ["Mensualmente", "Una vez al año", "Por cada hora"], c: 0, e: "Se acumula el uso y se factura a fin de mes." },
    },
    costexplorer: {
        nivel: "basico",
        cuando: ["Saber qué servicio, cuenta o etiqueta gasta más.", "Proyectar el gasto.", "Evaluar reservas y Savings Plans."],
        evita: ["Informes con cada línea de uso: Cost & Usage Report."],
        alt: [["cur", "Detalle completo para análisis propio."], ["budgets", "Avisa cuando el gasto se acerca a un límite."]],
        cobro: "La consola es gratuita; consultas por API tienen un costo pequeño por solicitud.",
        con: ["billing", "budgets", "cur"],
        quiz: { p: "¿Qué permite Cost Explorer?", o: ["Ver y filtrar el costo por servicio, cuenta o etiqueta", "Crear servidores", "Cifrar datos"], c: 0, e: "Es el análisis visual del gasto." },
    },
    budgets: {
        nivel: "basico",
        cuando: ["Avisar al llegar a un porcentaje del presupuesto.", "Límites por cuenta, servicio o etiqueta.", "Acciones automáticas al superar el límite."],
        evita: ["Entender las causas del gasto: Cost Explorer."],
        alt: [["costexplorer", "Análisis del gasto."]],
        cobro: "Incluye presupuestos sin costo y luego un cargo pequeño por presupuesto con acciones automáticas; confirma la tarifa vigente en la página de precios.",
        con: ["costexplorer", "sns", "billing"],
        quiz: { p: "¿Qué hace un presupuesto al cruzar un umbral?", o: ["Envía una alerta o ejecuta una acción", "Apaga la cuenta siempre", "Borra datos"], c: 0, e: "Notifica y puede aplicar políticas." },
    },
    cur: {
        nivel: "avanzado",
        cuando: ["Análisis detallado del costo con SQL.", "Asignar costos por equipo o proyecto.", "Integrar el gasto con tus herramientas."],
        evita: ["Revisiones rápidas: Cost Explorer."],
        alt: [["costexplorer", "Análisis visual."]],
        cobro: "El informe es gratuito; pagas el almacenamiento en S3 y las consultas (por ejemplo con Athena).",
        con: ["s3", "athena", "quicksight"],
        quiz: { p: "¿Dónde entrega AWS el Cost & Usage Report?", o: ["En un bucket de S3", "Por correo", "En CloudTrail"], c: 0, e: "Como archivos CSV o Parquet en S3." },
    },
};
